<span class='suggest-feedback' [attr.data-target]="'#' + uniqueIdPrefix">
  <button class='suggest-feedback-btn' (click)="open(content)" [ngbTooltip]="tipContent">
    <i class="fa fa-pencil hidden-md-down"></i>
    <img src="assets/images/edit.svg" class="hidden-lg-up mt-1" />
  </button>
</span>

<ng-template #tipContent>
  <ng-container *ngIf="!isAuthenticated">
    Login to suggest an edit to {{metricPrettyName}}
  </ng-container>
  <ng-container *ngIf="isAuthenticated">
    Suggest an edit to {{metricPrettyName}}
  </ng-container>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">
    <h6 class="modal-title text-uppercase" [attr.id]="uniqueIdPrefix + '-label'">Suggest an Edit to {{metricPrettyName}}
    </h6>
    <button type="button" class="close" (click)="modal.dismiss('Modal Closed')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group" *ngIf='_userService.isAnonymous()'>
        <label [attr.for]="uniqueIdPrefix + '-email'">Email</label>
        <input type='email' class="form-control" [attr.id]="uniqueIdPrefix + '-email'"
          [name]="uniqueIdPrefix + '-email'" [(ngModel)]='email' placeholder='Contact Email' maxlength='1000' />
      </div>
      <div class="form-group">
        <label [attr.for]="uniqueIdPrefix + '-description'">Description of Issue</label>
        <textarea class="form-control" [attr.id]="uniqueIdPrefix + '-description'"
          [name]="uniqueIdPrefix + '-description'" [(ngModel)]='description'
          placeholder='Briefly describe the issue. If relevant, please provide links to supporting documentation.'
          maxlength='1000'></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-block" data-dismiss="modal" (click)='modal.close()'
      [disabled]='!canSubmit'>Submit</button>
  </div>
</ng-template>